import {ActionContext, ActionTree, GetterTree, Module, MutationTree,} from "vuex";
import {watch} from "vue";

export class AlertBoxState {
  isOpen = false;
  message = "";
  shouldContinue: boolean | null = null;
}

const state: AlertBoxState = new AlertBoxState();

const mutations: MutationTree<AlertBoxState> = {
  IS_OPEN(state: AlertBoxState, isOpen: boolean): void {
    state.isOpen = isOpen;
  },
  MESSAGE(state: AlertBoxState, message: string): void {
    state.message = message;
  },
  SHOULD_CONTINUE(state: AlertBoxState, shouldContinue: boolean | null): void {
    state.shouldContinue = shouldContinue;
  },
};

const actions: ActionTree<AlertBoxState, AlertBoxState> = {
  async open(
    ctx: ActionContext<AlertBoxState, AlertBoxState>,
    message: string
  ): Promise<boolean> {
    ctx.commit("IS_OPEN", true);
    ctx.commit("MESSAGE", message);

    return await new Promise((resolve) => {
      watch(
        () => ctx.getters.shouldContinue,
        () => {
          if (state !== null) {
            resolve(ctx.getters.shouldContinue);
          }
        }
      );
    });
  },
  close({ commit }: ActionContext<AlertBoxState, AlertBoxState>): void {
    commit("IS_OPEN", false);
    commit("MESSAGE", "");
    commit("BUTTONS_TEXT", { continueAction: "", cancelAction: "" });
    commit("SHOULD_CONTINUE", null);
  },
  shouldContinue(
    { commit }: ActionContext<AlertBoxState, AlertBoxState>,
    shouldContinue: boolean
  ): void {
    commit("SHOULD_CONTINUE", shouldContinue);
  },
};

const getters: GetterTree<AlertBoxState, AlertBoxState> = {
  isOpen: (state: AlertBoxState): boolean => state.isOpen,
  message: (state: AlertBoxState): string => state.message,
  shouldContinue: (state: AlertBoxState): boolean | null =>
    state.shouldContinue,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<AlertBoxState, AlertBoxState>;
